
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import FloatingChatButton from "@/components/FloatingChatButton";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="pt-20 relative">
      <div className="h-[70vh] relative">
        <img
          src="/lovable-uploads/a7f40607-8c54-48a9-81b7-a1c99040a131.png"
          alt="Potato harvesting machinery in a field with distillery and mountains in the background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20">
          <div className="container mx-auto px-4 h-full flex items-center justify-end">
            <div className="max-w-3xl text-white text-right">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 animate-fade-up">
                Seed Potato<br />
                Organisation Ltd.
              </h1>
              <p className="text-xl text-white/90 mb-8 animate-fade-up" style={{ animationDelay: "0.2s" }}>
                Run by growers for growers
              </p>
              <div className="flex gap-4 justify-end">
                <Button 
                  size="default" 
                  className="bg-primary hover:bg-primary/90"
                  onClick={() => navigate('/membership')}
                >
                  Join Us
                </Button>
                <Button 
                  size="default" 
                  className="bg-white/10 text-white border border-white hover:bg-white/20"
                  onClick={() => navigate('/contact')}
                >
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingChatButton />
    </section>
  );
};

export default Hero;
